import React from 'react';
import { Instagram, MessageCircle } from 'lucide-react';
import { Logo } from './Logo';
export const Footer = () => {
  return <footer className="bg-[#1a0a10] text-white/80 pt-20 pb-8 px-6" data-id="element-45">
      <div className="max-w-6xl mx-auto" data-id="element-46">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-47">
          {/* Col 1 */}
          <div data-id="element-48">
            <div className="flex items-center gap-2 mb-6" data-id="element-49">
              <div className="w-10 h-10 rounded-full p-[2px] bg-gradient-ring flex items-center justify-center" data-id="element-50">
                <div className="w-full h-full bg-[#1a0a10] rounded-full flex items-center justify-center" data-id="element-51">
                  <span className="font-heading italic font-bold text-lg text-white" data-id="element-52">
                    BL
                  </span>
                </div>
              </div>
              <span className="font-heading font-semibold text-xl tracking-wide text-white" data-id="element-53">
                Beauty Lab
              </span>
            </div>
            <p className="text-brand-bg/70 max-w-xs leading-relaxed" data-id="element-54">
              Belleza, cosmética y cuidado personal. Un espacio dedicado a
              realzar tu mejor versión.
            </p>
          </div>

          {/* Col 2 */}
          <div data-id="element-55">
            <h4 className="text-white font-heading font-bold text-lg mb-6" data-id="element-56">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-4" data-id="element-57">
              <li data-id="element-58">
                <a href="#servicios" className="hover:text-brand-pink transition-colors" data-id="element-59">
                  Servicios
                </a>
              </li>
              <li data-id="element-60">
                <a href="#nosotras" className="hover:text-brand-pink transition-colors" data-id="element-61">
                  Nosotras
                </a>
              </li>
              <li data-id="element-62">
                <a href="#horarios" className="hover:text-brand-pink transition-colors" data-id="element-63">
                  Horarios
                </a>
              </li>
              <li data-id="element-64">
                <a href="#contacto" className="hover:text-brand-pink transition-colors" data-id="element-65">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3 */}
          <div data-id="element-66">
            <h4 className="text-white font-heading font-bold text-lg mb-6" data-id="element-67">
              Contacto & Redes
            </h4>
            <div className="flex gap-4 mb-6" data-id="element-68">
              <a href="#" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-pink hover:text-white transition-all" data-id="element-69">
                <Instagram size={20} data-id="element-70" />
              </a>
              <a href="#" className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-pink hover:text-white transition-all" data-id="element-71">
                <MessageCircle size={20} data-id="element-72" />
              </a>
            </div>
            <p className="text-brand-bg/70" data-id="element-73">
              26 de Marzo 3420
              <br data-id="element-74" />
              Montevideo, Uruguay
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-sm text-brand-bg/50" data-id="element-75">
          <p data-id="element-76">© {new Date().getFullYear()} Beauty Lab · Montevideo, Uruguay</p>
        </div>
      </div>
    </footer>;
};